import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';
import { StoreProvider } from './store/store';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Brand, isAdeed } from './constants/brand';
import { applyThemeMode } from './common/theme-mode/theme-mode';

// ADEED: light or dark (Settings > Appearance) on <html> before the first render, so dark never flashes light.
if (isAdeed) applyThemeMode();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StoreProvider>
    {/* <HashRouter> */}
      {/* <App /> */}
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      <App />
    </GoogleReCaptchaProvider>


    {/* </HashRouter> */}
  </StoreProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ADEED Freight build: tab title, and the ADEED palette/font (src/index.css :root[data-brand='adeed'])
if (isAdeed) {
  document.title = Brand.appName;
  document.documentElement.dataset.brand = "adeed";
}
